export default __webpack_public_path__ + "static/videojuegosicon-dc08165fb2c8048ecce4da46060594a6.webp";